// Deterministic colourful avatar palette used wherever a person doesn't have a
// photo - keeps each individual visually distinct (pod chat, member lists, etc).
// Flat, single-hue 90deg gradients (no diagonal/glossy look) matching the app's
// existing flat gradient accents (see feedProfile.tsx community cards).
const AVATAR_PALETTE: string[] = [
  'linear-gradient(90deg, #2f66d0 0%, #5f86dd 100%)', // blue
  'linear-gradient(90deg, #8256d4 0%, #b085ef 100%)', // purple
  'linear-gradient(90deg, #2f879e 0%, #64a7bf 100%)', // teal
  'linear-gradient(90deg, #b96820 0%, #d89a61 100%)', // orange
  'linear-gradient(90deg, #2f9b66 0%, #73c79a 100%)', // green
  'linear-gradient(90deg, #c23b6b 0%, #e07898 100%)', // pink
  'linear-gradient(90deg, #b0392f 0%, #d97a6e 100%)', // red
  'linear-gradient(90deg, #8a8f28 0%, #b6ba5e 100%)', // olive
];

// Branded fallback avatar image shown for a person with no profile photo. Prefer this over
// rendering initials so every "no photo" state looks intentional rather than like a placeholder.
export const DEFAULT_AVATAR_SRC = '/assets/images/default-avatar.svg';

function hashSeed(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    // Normalise to a 32-bit signed integer after every step - without this the
    // running total grows/oscillates unbounded and different seeds collapse to
    // near-identical magnitudes, causing almost everyone to land in the same
    // palette bucket after the modulo below.
    hash |= 0;
  }
  return Math.abs(hash);
}

/** Deterministic avatar background token (currently a flat 90° CSS gradient) for callers that need a stable colour value. */
export function getAvatarColor(seed: string): string {
  return AVATAR_PALETTE[hashSeed(seed) % AVATAR_PALETTE.length];
}

/** Deterministic flat gradient background for a given seed (user/pod id, name, etc). */
export function getAvatarGradient(seed: string): string {
  return AVATAR_PALETTE[hashSeed(seed) % AVATAR_PALETTE.length];
}
